export const SHN_ANALYTICS_ICON_128_URL = "https://d29aimug5u0wth.cloudfront.net/images/shn-analytics-robot_128.gif"
export const DISCORD_INVITE_URL = "https://discord.gg/WF5xQfaZjN"
export const DISCORD_LOGO_URL = "https://d29aimug5u0wth.cloudfront.net/images/discord_logo.gif"